
import React from "react";

import { t, Trans } from "@lingui/macro";
import { ErrorResponse, Loading, MatesMultilineTextField, MatesTextField, RestResponse, withUseFormHook } from "@sinossi/mates-react-library";
import { UseFormReturn } from "react-hook-form";

import * as Yup from "yup";

import { Autocomplete, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, Typography } from "@mui/material";
import { CustomDropzoneUploadDocument } from "components/brand/customDropzoneUploadDocument";
import { MatesComponent, MatesComponentState } from "components/mates-component";
import { PaginatedResponse, Zone } from "models";
import { UseRouterParams } from "services/router";
import { ZoneServices } from "services/zone.services";

const MicrojobDetailModalValidation = Yup.object().shape({
    title: Yup.string().required("Il campo è obbligatorio")
})

export interface MicrojobDetailModalProps extends UseFormReturn, UseRouterParams {
    onClose: () => void
    onMicrojobConclude: (answer: string) => void
    onMicrojobTake?: () => void
    onMicrojobConfirm?: () => void
    submit: (request: any) => void
    microjob: any,
    isAdmin: boolean
}

export interface MicrojobDetailModalState extends MatesComponentState {
    loading: boolean,
    answer: string,
    zonesTimeout: any,
    zoneValue: any,
    taskValue: any,
    zoneInputValue: string
    zoneOptions: Zone[],
}

class MicrojobDetailModal extends React.Component<MicrojobDetailModalProps, MicrojobDetailModalState> {

    private readonly matesComponent: MatesComponent<MicrojobDetailModalProps, MicrojobDetailModalState> = new MatesComponent(this)

    private readonly MICROJOB_TASK_TYPES = [{ name: "Tour 3D", id: "TOUR_3D" }, { name: "Ricerca immobili", id: "RICERCA_IMMOBILI" }]

    constructor(props: MicrojobDetailModalProps) {

        super(props);
        this.state = {
            ...this.matesComponent.setupState(),
            loading: true,
            zonesTimeout: null,
            zoneValue: null,
            taskValue: null,
            zoneInputValue: "",
            answer: "",
            zoneOptions: [],
        }
    }

    componentDidMount() {

        if (this.props.microjob) {
            this.props.reset(this.props.microjob)
        }

        this.setState(() => ({
            loading: false
        }))
    }

    private fetchZones = (input: string) => {
        if (this.state.zonesTimeout) {
            clearTimeout(this.state.zonesTimeout)
        }
        this.setState(() => ({
            zonesTimeout: setTimeout(() => this.handleZoneChange(input), 400)
        }))
    }

    private handleZoneChange = (value: string) => {

        this.setState(() => ({
            loading: true
        }))


        if (value !== "") {
            let request: any = {
                name: value,
                pageSize: 20
            }

            ZoneServices.getFilteredZones(request, this.handleZoneChangeCallback, this.matesComponent.onError)
        }
    }

    private handleAnswerChange = (value: string) => {

        this.setState(() => ({
            answer: value
        }))

        console.log(value)

        return value
    }

    private handleZoneChangeCallback = (response: RestResponse<PaginatedResponse<any>, ErrorResponse>) => {
        if (response.hasError()) {
            this.matesComponent.onError(response)
            return
        }

        if (response.data) {
            this.setState(() => ({
                zoneOptions: response.data!.items,
                loading: false
            }))
        }
    }

    private submit = (data: any) => {

        this.props.submit(data)

    }

    private handleValidation = () => {
        return true
    }

    render() {

        const { isAdmin, microjob } = this.props
        const { zoneValue, zoneOptions, taskValue } = this.state

        return (
            <>
                <Loading show={this.state.loading} />
                <Dialog open={true} onClose={this.props.onClose} fullWidth maxWidth="md">
                    <DialogTitle>
                        <Typography variant="h5">
                            <Trans id="mjm-title">Dettagli Microjob</Trans>
                        </Typography>
                    </DialogTitle>
                    <form onSubmit={this.props.handleSubmit(this.submit, this.handleValidation)}>
                        <DialogContent>
                            <Grid container spacing={2} p={2}>
                                <Grid item xs={12} md={9}>
                                    <MatesTextField variant="outlined"
                                        label={t({
                                            id: "mjd-modal.title",
                                            message: "Titolo",
                                        })}
                                        name="title"
                                        control={this.props.control}
                                        trigger={this.props.trigger}
                                        formState={this.props.formState}
                                        disabled={!isAdmin}
                                        required
                                    />
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <MatesTextField variant="outlined"
                                        label={t({
                                            id: "mjd-modal.price",
                                            message: "Valore economico",
                                        })}
                                        name="price"
                                        control={this.props.control}
                                        trigger={this.props.trigger}
                                        formState={this.props.formState}
                                        disabled={!isAdmin}
                                        endAdornment={
                                            <Typography>
                                                €
                                            </Typography>
                                        }
                                        required
                                    />
                                </Grid>
                                <Grid item xs={12} md={12} sx={{ mt: 1 }}>
                                    <MatesMultilineTextField variant="outlined"
                                        label={t({
                                            id: "mjd-modal.description",
                                            message: "Descrizione",
                                        })}
                                        name="description"
                                        minRows={6}
                                        maxRows={6}
                                        maxLength={5000}
                                        control={this.props.control}
                                        trigger={this.props.trigger}
                                        formState={this.props.formState}
                                        disabled={!isAdmin}
                                        required
                                    />
                                </Grid>
                                {(microjob && (microjob.status === "ASSIGNED" || microjob.status === "IN_REVIEW" || microjob.status === "COMPLETED")) && <>
                                    <Grid item xs={12} md={12} sx={{ mt: 1 }}>
                                        <MatesMultilineTextField variant="outlined"
                                            label={t({
                                                id: "mjd-modal.response",
                                                message: "Risposta",
                                            })}
                                            name="response"
                                            minRows={3}
                                            maxRows={3}
                                            onChange={(data: string) => this.handleAnswerChange(data)}
                                            maxLength={2048}
                                            control={this.props.control}
                                            trigger={this.props.trigger}
                                            formState={this.props.formState}
                                            disabled={isAdmin}
                                            required
                                        />
                                    </Grid>
                                    {(microjob.status === "ASSIGNED") && <Grid item xs={12} md={12} sx={{ mt: 1 }}>
                                        <CustomDropzoneUploadDocument callback={() => { }} text={"Carica allegato"} />
                                    </Grid>}
                                </>}
                                {(isAdmin && !microjob) && <>
                                    <Grid item xs={12} md={6} sx={{ mt: 1 }}>
                                        <Autocomplete
                                            getOptionLabel={(option) => option.name}
                                            filterOptions={(x) => x}
                                            options={zoneOptions}
                                            autoComplete
                                            includeInputInList
                                            filterSelectedOptions
                                            //isOptionEqualToValue={(x, value) => x.id === value.id}
                                            value={zoneValue}
                                            noOptionsText={t({ id: "mj-detail-modal.no-zone", message: "Inizia a digitare per avviare la ricerca" })}
                                            onChange={(event, newValue) => {
                                                if (newValue) {
                                                    this.setState(() => ({
                                                        zoneValue: newValue, zoneOptions: [newValue, ...zoneOptions]
                                                    }));
                                                    this.props.setValue("zoneId", newValue.id)
                                                }
                                            }}
                                            onInputChange={(event, newInputValue) => {

                                                this.setState({ zoneInputValue: newInputValue }, () => {
                                                    if (this.state.zoneInputValue === '') {
                                                        this.setState({ zoneOptions: zoneValue ? [zoneValue] : [] });
                                                    }
                                                    else {
                                                        this.fetchZones(this.state.zoneInputValue)
                                                    }
                                                })
                                            }}
                                            renderInput={(params) => (
                                                <TextField {...params}
                                                    label={t({ id: "mjd-modal.select-zone", message: "Zona" })}
                                                    fullWidth
                                                    required
                                                />
                                            )} />
                                    </Grid>
                                    <Grid item xs={12} md={6} sx={{ mt: 1 }}>
                                        <Autocomplete
                                            getOptionLabel={(option) => option.name}
                                            filterOptions={(x) => x}
                                            options={this.MICROJOB_TASK_TYPES}
                                            autoComplete
                                            includeInputInList
                                            filterSelectedOptions
                                            value={taskValue}
                                            noOptionsText={t({ id: "mj-detail-modal.no-task", message: "Cerca task" })}
                                            onChange={(event, newValue) => {
                                                if (newValue) {

                                                    this.setState(() => ({
                                                        taskValue: newValue
                                                    }));
                                                    this.props.setValue("task", newValue.id)
                                                }
                                            }}
                                            renderInput={(params) => (
                                                <TextField {...params}
                                                    label={t({ id: "mjd-modal.select-task", message: "Task" })}
                                                    fullWidth
                                                    required
                                                />
                                            )} />
                                    </Grid>
                                </>}
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.props.onClose}
                                variant={"outlined"}
                                color="neutral"
                                sx={{
                                    textTransform: "none",
                                    mr: 1,
                                    width: 100
                                }}
                                disableElevation>
                                <Trans id={"mjdm.close-button"}>
                                    Chiudi
                                </Trans>
                            </Button>
                            {(isAdmin && !this.props.microjob) && <Button
                                type="submit"
                                variant={"contained"}
                                color="primary"
                                sx={{
                                    textTransform: "none",
                                    mr: 1,
                                    width: 100
                                }}
                                disableElevation>
                                <Trans id={"mjdm.create"}>
                                    Crea
                                </Trans>
                            </Button>}
                            {(isAdmin && this.props.microjob && this.props.microjob.status === "IN_REVIEW") && <Button
                                onClick={this.props.onMicrojobConfirm}
                                variant={"contained"}
                                color="secondary"
                                sx={{
                                    textTransform: "none",
                                    mr: 1,
                                    width: 100
                                }}
                                disableElevation>
                                <Trans id={"mjdm.confirm"}>
                                    Conferma
                                </Trans>
                            </Button>}
                            {!isAdmin && <>
                                {(microjob && microjob.status === "ASSIGNED") && <Button onClick={() => this.props.onMicrojobConclude(this.state.answer)}
                                    variant={"contained"}
                                    color="primary"
                                    sx={{
                                        textTransform: "none",
                                        mr: 1,
                                        width: 100
                                    }}
                                    disableElevation>
                                    <Trans id={"mjdm.complete-button"}>
                                        Completa
                                    </Trans>
                                </Button>}
                                {(microjob && microjob.status === "CREATED") && <Button onClick={this.props.onMicrojobTake}
                                    variant={"contained"}
                                    color="secondary"
                                    sx={{
                                        textTransform: "none",
                                        mr: 1,
                                    }}
                                    disableElevation>
                                    <Trans id={"mjdm.take-button"}>
                                        Prendi in carico
                                    </Trans>
                                </Button>}
                            </>}
                        </DialogActions>
                    </form>
                </Dialog >
            </>
        )
    }
}

export default withUseFormHook<{}>(
    MicrojobDetailModal,
    MicrojobDetailModalValidation,
    {}
)
